<template>
    <div>
        <div v-if="!fetchLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">{{$t("branch")}}</h4>
                    <p class="text-subtitle-1">{{$t("edit_branch")}}</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <BranchForm ref="form" v-model="data"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn block color="primary" @click="onSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        {{$t("save_btn")}}
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3">
                    <v-btn block depressed @click="onCancel">
                        {{$t("cancel_btn")}}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </div>
</template>

<script>
import BranchForm from './../../components/Sales/BranchForm.vue';
import PAlert from '../../components/common/PAlert.vue';
import branch from '../../services/sales/branch';
export default {
    components: {
        BranchForm,
        PAlert
    },
    data() {
        return {
            data: {},
            id: null,
            alert: {
                display: false,
                content: "Are you sure?",
                callback: null
            },
            loading: false,
            fetchLoading: false
        }
    },
    methods: {
        onSave() {
            this.alert = { ...this.alert, display: true, content: this.$t("are_you_sure_you_want_to_save"), callback: this.save };
        },
        save() {
            if(!this.$refs.form.$refs.form.validate()) return;
            this.loading = true;
            branch.update(this.id, {...this.data}).then(res => {
                this.$router.replace({
                    name: "BranchDisplay",
                    params: {
                        id: res.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        onCancel() {
            this.alert = { ...this.alert, display: true, content: this.$t("are_you_sure_cancel"), callback: this.cancel };
        },
        cancel() {
            this.$router.back();
        },
        fetch() {
            this.fetchLoading = true;
            branch.get(this.id).then(res => {
                this.data = {
                    ...res.data,
                    dimension: res.data.dimention,
                    dimension_id: res.data.dimension.id
                };
            }).finally(() => {
                this.fetchLoading = false;
            })
        }
    },
    created() {
        this.id = this.$route.params.id;
        this.fetch();
    }
}
</script>

<style>

</style>